// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__UIwkN","navHidden":"Navbar_navHidden__SvX2R"};